// src/views/condominos/fichaPdfHelper.js
// Geração da Ficha do Condômino em PDF (HTML imprimível em janela popup)

function fmtDt(v) {
  if (!v) return "—";
  try { return new Date(String(v).split("T")[0] + "T12:00:00").toLocaleDateString("pt-BR"); }
  catch { return v; }
}

function escape(s) {
  return String(s ?? "").replace(/[<>&"]/g, c => ({"<":"&lt;",">":"&gt;","&":"&amp;","\"":"&quot;"}[c]));
}

export function gerarFichaPdf({ condomino: c, vinculos = [], documentos = [] }) {
  const w = window.open("", "_blank", "width=900,height=1200");
  if (!w) return alert("Bloqueado por pop-up. Permita pop-ups para gerar a ficha.");
  const html = `<!doctype html>
<html lang="pt-BR"><head><meta charset="utf-8"><title>Ficha do Condômino — ${escape(c.nmCompleto)}</title>
<style>
  *{box-sizing:border-box} body{font-family:Arial,Helvetica,sans-serif;color:#1f2937;margin:0;padding:24px;font-size:12px}
  h1{font-size:20px;margin:0 0 4px;color:#1B3A6B}
  h2{font-size:14px;margin:18px 0 8px;color:#1B3A6B;border-bottom:2px solid #1B3A6B;padding-bottom:3px}
  table{width:100%;border-collapse:collapse;margin-bottom:8px;font-size:11px}
  th,td{border:1px solid #cbd5e1;padding:5px 8px;text-align:left;vertical-align:top}
  th{background:#F1F5F9;font-weight:600}
  .grid{display:grid;grid-template-columns:repeat(2,1fr);gap:8px 16px}
  .row{display:flex;gap:8px}
  .lbl{font-weight:600;color:#475569;min-width:120px;display:inline-block}
  .avatar{width:80px;height:80px;border-radius:50%;background:#E2E8F0;display:flex;align-items:center;justify-content:center;color:#94a3b8;font-size:32px;flex-shrink:0;border:2px solid #fff;box-shadow:0 0 0 1px #cbd5e1}
  .header{display:flex;align-items:center;gap:18px;margin-bottom:8px}
  .badge{display:inline-block;padding:2px 8px;border-radius:12px;font-size:10px;font-weight:600;background:#EFF6FF;color:#1B3A6B}
  @media print { body{padding:14px} .no-print{display:none} }
</style></head>
<body>
  <div class="header">
    <div class="avatar" ${c.avatar?`style="background:url('${escape(c.avatar)}') center/cover;border:none;box-shadow:0 0 0 1px #cbd5e1"`:""}>
      ${c.avatar?"":"&#128100;"}
    </div>
    <div>
      <h1>${escape(c.nmCompleto)}</h1>
      <div style="color:#64748b">
        ${escape(c.tpPessoa==="Juridica"?"Pessoa Jurídica":"Pessoa Física")} •
        ${escape(c.cpf_cnpj||"sem documento")} •
        Cadastro ${fmtDt(c.dtCadastro)}
        ${c.inativo?"<span class='badge' style='background:#FEE2E2;color:#B91C1C'>INATIVO</span>":"<span class='badge' style='background:#DCFCE7;color:#166534'>ATIVO</span>"}
      </div>
    </div>
  </div>

  <h2>Identificação</h2>
  <div class="grid">
    <div><span class="lbl">RG / Insc.Estadual:</span> ${escape(c.rg||c.inscEstadual||"—")}</div>
    <div><span class="lbl">Nascimento:</span> ${fmtDt(c.dtNascimento)}</div>
    <div><span class="lbl">Sexo:</span> ${escape(c.sexo||"—")}</div>
    <div><span class="lbl">Estado Civil:</span> ${escape(c.estCivil||"—")}</div>
    <div><span class="lbl">Nacionalidade:</span> ${escape(c.nacionalidade||"—")}</div>
    <div><span class="lbl">Profissão:</span> ${escape(c.profissao||"—")}</div>
  </div>

  <h2>Contato</h2>
  <div class="grid">
    <div><span class="lbl">E-mail:</span> ${escape(c.email||"—")}</div>
    <div><span class="lbl">Celular:</span> ${escape(c.celular||"—")}</div>
    <div><span class="lbl">WhatsApp:</span> ${escape(c.nrWhatsApp||"—")}</div>
    <div><span class="lbl">Telefone:</span> ${escape(c.telefone||"—")}</div>
    <div><span class="lbl">Tel. Comercial:</span> ${escape(c.telComercial||"—")}</div>
    <div><span class="lbl">Local de Trabalho:</span> ${escape(c.localTrabalho||"—")}</div>
  </div>

  <h2>Endereço Pessoal</h2>
  <div>
    ${escape(c.logradouro||"")}${c.numero?`, ${escape(c.numero)}`:""}${c.complemento?` — ${escape(c.complemento)}`:""}<br/>
    ${escape(c.bairro||"")} • ${escape(c.cidade||"")}/${escape(c.uf||"")} • CEP ${escape(c.cep||"—")}
  </div>

  ${c.estCivil==="Casado" ? `
    <h2>Cônjuge</h2>
    <div class="grid">
      <div><span class="lbl">Nome:</span> ${escape(c.nmConjuge||"—")}</div>
      <div><span class="lbl">CPF:</span> ${escape(c.cpfConjuge||"—")}</div>
      <div><span class="lbl">RG:</span> ${escape(c.rgConjuge||"—")}</div>
      <div><span class="lbl">Profissão:</span> ${escape(c.profConjuge||"—")}</div>
      <div><span class="lbl">Nascimento:</span> ${fmtDt(c.dtNascConjuge)}</div>
    </div>
  ` : ""}

  ${(c.pixChave || c.bancoConta) ? `
    <h2>Dados Bancários</h2>
    <div class="grid">
      <div><span class="lbl">PIX:</span> ${escape(c.pixTipo||"—")} — ${escape(c.pixChave||"—")}</div>
      <div><span class="lbl">Banco:</span> ${escape(c.bancoNome||"—")}</div>
      <div><span class="lbl">Agência / Conta:</span> ${escape(c.bancoAgencia||"—")} / ${escape(c.bancoConta||"—")}</div>
      <div><span class="lbl">Tipo:</span> ${escape(c.bancoTpConta||"—")}</div>
    </div>
  ` : ""}

  <h2>Vínculos com Unidades (${vinculos.length})</h2>
  ${vinculos.length === 0 ? '<div style="color:#94a3b8">Nenhum vínculo cadastrado.</div>' : `
  <table>
    <thead><tr><th>Condomínio</th><th>Unidade</th><th>Tipo</th><th>Início</th><th>Fim</th><th>Status</th></tr></thead>
    <tbody>
      ${vinculos.map(v => `<tr>
        <td>${escape(v.nmCondominio||"—")}</td>
        <td>${escape(v.unidade||"—")}${v.bloco?` / ${escape(v.bloco)}`:""}</td>
        <td>${escape(v.tpVinculo||"—")}</td>
        <td>${fmtDt(v.dtInicio)}</td>
        <td>${fmtDt(v.dtFim)}</td>
        <td>${v.ativo?"Ativo":"Inativo"}</td>
      </tr>`).join("")}
    </tbody>
  </table>`}

  ${documentos.length ? `
    <h2>Documentos Anexos (${documentos.length})</h2>
    <table>
      <thead><tr><th>Tipo</th><th>Arquivo</th><th>Descrição</th><th>Enviado em</th></tr></thead>
      <tbody>
        ${documentos.map(d => `<tr>
          <td>${escape(d.tipo)}</td>
          <td>${escape(d.nomeArquivo||"—")}</td>
          <td>${escape(d.descricao||"—")}</td>
          <td>${new Date(d.createdAt).toLocaleDateString("pt-BR")}</td>
        </tr>`).join("")}
      </tbody>
    </table>
  ` : ""}

  ${c.lgpdAceite ? `<p style="margin-top:18px;font-size:11px;color:#475569"><strong>LGPD:</strong> Termo aceito em ${new Date(c.lgpdAceiteEm).toLocaleString("pt-BR")} — versão ${escape(c.lgpdVersao||"1.0")}.</p>` : ""}

  <div style="margin-top:30px;font-size:10px;color:#94a3b8;text-align:center">
    Documento gerado em ${new Date().toLocaleString("pt-BR")} • Horizon eCondo — Ficha do Condômino
  </div>

  <div class="no-print" style="margin-top:14px;text-align:center">
    <button onclick="window.print()" style="padding:8px 24px;background:#1B3A6B;color:#fff;border:none;border-radius:6px;cursor:pointer">🖨 Imprimir / Salvar PDF</button>
  </div>

  <script>setTimeout(()=>{window.print()},400);</script>
</body></html>`;
  w.document.write(html);
  w.document.close();
}
